import { Skeleton } from '@/module/payment/Checkout/layout/skeleton/Skeleton';
import { PricingCard } from '@/shared/components/PricingCard';
import { cn } from '@/utils/tailwind.util';
export const IndividualPlanCardsSkeleton = ({
  className
}: {
  className?: string;
}) => <div aria-hidden className={cn('pointer-events-none absolute inset-0', className)} data-sentry-component="IndividualPlanCardsSkeleton" data-sentry-source-file="IndividualPlanCardsSkeleton.tsx">
    <PricingPlanCardSkeleton featureRows={4} data-sentry-element="PricingPlanCardSkeleton" data-sentry-source-file="IndividualPlanCardsSkeleton.tsx" />
    <PricingPlanCardSkeleton featureRows={2} aiFeatureRows={1} data-sentry-element="PricingPlanCardSkeleton" data-sentry-source-file="IndividualPlanCardsSkeleton.tsx" />
    <PricingPlanCardSkeleton featureRows={4} aiFeatureRows={4} data-sentry-element="PricingPlanCardSkeleton" data-sentry-source-file="IndividualPlanCardsSkeleton.tsx" />
  </div>;
const PricingPlanCardSkeleton = ({
  featureRows,
  aiFeatureRows = 0
}: {
  featureRows: number;
  aiFeatureRows?: number;
}) => <PricingCard.Container className="min-h-0 flex-1" data-sentry-element="unknown" data-sentry-component="PricingPlanCardSkeleton" data-sentry-source-file="IndividualPlanCardsSkeleton.tsx">
    <PricingCard.TopSection data-sentry-element="unknown" data-sentry-source-file="IndividualPlanCardsSkeleton.tsx">
      <Skeleton className="h-[39px] w-[112px] motion-reduce:animate-none" data-sentry-element="Skeleton" data-sentry-source-file="IndividualPlanCardsSkeleton.tsx" />
      <Skeleton className="h-[52px] w-[180px] motion-reduce:animate-none" data-sentry-element="Skeleton" data-sentry-source-file="IndividualPlanCardsSkeleton.tsx" />
      <div className="flex flex-col gap-3xs">
        <Skeleton className="h-[20px] w-full motion-reduce:animate-none" data-sentry-element="Skeleton" data-sentry-source-file="IndividualPlanCardsSkeleton.tsx" />
        <Skeleton className="h-[20px] w-2/3 motion-reduce:animate-none" data-sentry-element="Skeleton" data-sentry-source-file="IndividualPlanCardsSkeleton.tsx" />
      </div>
      <Skeleton className="h-[48px] w-full motion-reduce:animate-none" data-sentry-element="Skeleton" data-sentry-source-file="IndividualPlanCardsSkeleton.tsx" />
    </PricingCard.TopSection>

    <PricingCard.Divider data-sentry-element="unknown" data-sentry-source-file="IndividualPlanCardsSkeleton.tsx" />

    <PricingCard.BottomSection className="flex-1" data-sentry-element="unknown" data-sentry-source-file="IndividualPlanCardsSkeleton.tsx">
      <div className="flex flex-col gap-2xs">
        <Skeleton className="h-[22px] w-2/5 motion-reduce:animate-none" data-sentry-element="Skeleton" data-sentry-source-file="IndividualPlanCardsSkeleton.tsx" />
        <Skeleton className="h-[20px] w-3/5 motion-reduce:animate-none" data-sentry-element="Skeleton" data-sentry-source-file="IndividualPlanCardsSkeleton.tsx" />
      </div>
      <div className="flex flex-col gap-xs">
        {Array.from({
        length: featureRows
      }).map((_, index) => <div key={index} className="flex items-center gap-2xs">
            <Skeleton className="size-[20px] shrink-0 !rounded-full motion-reduce:animate-none" />
            <Skeleton className="h-[20px] w-4/5 motion-reduce:animate-none" />
          </div>)}
      </div>
      {aiFeatureRows > 0 && <div className="flex flex-col gap-sm rounded-md bg-neutral px-lg py-sm">
          <Skeleton className="h-[24px] w-[96px] motion-reduce:animate-none" />
          <div className="flex flex-col gap-xs">
            {Array.from({
          length: aiFeatureRows
        }).map((_, index) => <Skeleton key={index} className="h-[20px] w-4/5 motion-reduce:animate-none" />)}
          </div>
        </div>}
    </PricingCard.BottomSection>
    <Skeleton className="mx-auto mb-md h-[18px] w-[120px] motion-reduce:animate-none" data-sentry-element="Skeleton" data-sentry-source-file="IndividualPlanCardsSkeleton.tsx" />
  </PricingCard.Container>;